import Fuse from "fuse.js"
import debounce from "lodash/debounce"

const serviceConnectSearch = () => {
  const searchInput = document.getElementById("service-search") as HTMLInputElement
  if (searchInput) {
    const serviceName = searchInput.dataset.serviceName

    if (window.innerWidth < 724) { // match phone width, esbuild doesn't support variable export
      searchInput.placeholder = `Search ${serviceName}`
    }

    const serviceCards = Array.from(document.querySelectorAll(".service-card-list-item"))

    const searchableCards = serviceCards.map(card => ({
      element: card,
      serviceName: (card as HTMLElement).dataset.serviceName || ""
    }))

    const fuse = new Fuse(searchableCards, {
      keys: ["serviceName"],
      includeScore: true,
      threshold: 0.3, // Lower = more strict matching (0.0 = exact, 1.0 = match anything)
    })

    const handleInput = (event: Event) => {
      const searchTerm = (event.target as HTMLInputElement).value.toLowerCase().trim()

      serviceCards.forEach(card => card.classList.add("hide"))

      if (searchTerm === "") {
        serviceCards.slice(0, 12).forEach(card => card.classList.remove("hide"))
      } else {
        const results = fuse.search(searchTerm).slice(0, 12)
        results.forEach(result => result.item.element.classList.remove("hide"))
        window.App.Utils.logCustomDatadogAction?.("service_connect_filter_started")
      }
    }

    const debouncedHandleInput = debounce(handleInput, 250)

    searchInput.addEventListener("input", debouncedHandleInput)
  }
}

export default serviceConnectSearch
